import web from "@/core/middlewares/web";

let index = () => import(/* webpackChunkName: "admins" */ '@/views/admins/Index');
let create = () => import(/* webpackChunkName: "admins" */ '@/views/admins/Create');
let changePassword = () => import(/* webpackChunkName: "admins" */ '@/views/admins/ChangePassword');
let security = () => import(/* webpackChunkName: "admins" */ '@/views/admins/Security');
let edit = () => import(/* webpackChunkName: "admins" */ '@/views/admins/Edit');
let role = () => import(/* webpackChunkName: "admins" */ '@/views/admins/Role');

export default [
    {
        path: "/admins",
        name: "admins.index",
        component: index,
        meta: {
            middleware: web,
            permissions: ['admins:viewAny'],
            title: "مدیران"
        }
    },
    {
        path: "/admins/create",
        name: "admins.create",
        component: create,
        meta: {
            middleware: web,
            permissions: ['admins:create'],
            title: "ایجاد مدیر"
        }
    },
    {
        path: "/admins",
        component: () => import("@/views/admins/Layout"),
        children: [
            {
                path: ":admin",
                name: "admins.edit",
                components: {
                    admins: edit
                },
                meta: {
                    middleware: web,
                    permissions: ['admins:update'],
                    title: "ویرایش مدیر"
                }
            },
            {
                path: ":admin/change-password",
                name: "admins.change_password",
                components: {
                    admins: changePassword
                },
                meta: {
                    middleware: web,
                    permissions: ['admins:changePassword'],
                    title: "تغییر گذرواژه"
                },
            },
            {
                path: ":admin/role",
                name: "admins.role",
                components: {
                    admins: role
                },
                meta: {
                    middleware: web,
                    permissions: ['admins:role'],
                    title: "سطح دسترسی"
                },
            },

            {
                path: ":admin/security",
                name: "admins.security",
                components: {
                    admins: security
                },
                meta: {
                    middleware: web,
                    permissions: ['admins:security'],
                    title: "تنظیمات امنیتی"
                }
            },
        ]
    },


]